/**
 * Typed errors surfaced by the upload engine so callers can react cleanly
 * (e.g. show a sign-in prompt vs a generic failure toast).
 */

export class NotAuthenticatedError extends Error {
  readonly code = "NOT_AUTHENTICATED";
  constructor(message = "You must be signed in to upload") {
    super(message);
    this.name = "NotAuthenticatedError";
  }
}
